import React, {useState, useMemo, useCallback, useEffect} from 'react';
import * as Yup from 'yup';
import {
  Button,
  Box,
  Card,
  Typography,
  MenuItem,
  Menu,
  FormHelperText
} from '@mui/material';
import Iconify from 'src/components/iconify';
import {Controller, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import FormProvider, {RHFEditor} from 'src/minimal-components/hook-form';
import parse from 'html-react-parser';
import QuestionForm from '../../Prepostlearning/Assessment/Addquestion/AddQuestion';
import DragDropContentDisplay from '../../Prepostlearning/Assessment/Addquestion/dragdrop';
import {useAppContext} from '@context/AppContext';
import {getLMSResultsData} from '@shared/services/service-handlers/PrivateService';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useOnlineContext} from './OnlineTestContext';
import Editor from 'src/minimal-components/editor/editor';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {enqueueSnackbar} from 'notistack';
import QuestionFormOnlineTest from './AddQuestionOnline';
import DragDropQuestion from './DragDropQuestion';
import {BASE_RECORD_ID} from 'src/routes/BaseRoute';
interface QuestionOptionProps {
  uiFields?: any;
  insertdata?: any;
  setDropDownData?: any;
  dropDownData?: any;
  setSaveRef: React.MutableRefObject<(() => Promise<boolean>) | null>;
}
const overviewData = `
<ul>
  <li>It’s time to test your knowledge! When you are ready, click ’Start’ to take the test.</li>
  <li>Clicking on ’Start’ will be counted as an attempt.</li>
  <li>All questions must be answered within the given duration. Answers cannot be changed later.</li>
  <li>Unanswered questions will be considered as incorrect answers.</li>
  <li>Even if there are unanswered questions when time concludes, it still counts as one attempt.</li>
  <li>You can view the results at the end of the test.</li>
  <li>Liaise with suppliers and source elements.</li>
</ul>

<br/>
<h4>All The Best</h4>
`;
const thankyouData = `

<h3>Thank you for taking the test</h3>
`;

const QuestionSetupOnlineTest: React.FC<QuestionOptionProps> = ({
  setSaveRef
}) => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const {onlineData, setOnlineData} = useOnlineContext();
  const {questionsData, setQuestionData} = useOnlineContext();
  const {uiFields, setUiFields} = useOnlineContext();
  const {dropDowndata, setDropDownData} = useOnlineContext();
  const {optionsRendered, setOptionsRendered} = useOnlineContext();
  const {screenSave, setScreenSave} = useOnlineContext();
  const [screenLoader, setScreenLoader] = useState(false);
  const {questionLoader, setQuestionLoader} = useOnlineContext();
  const [opening, setOpening] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editQuestions, setEditQuestions] = useState<any>();
  const [intromode, setIntromode] = useState(false);
  const [thanksdata, setThanksdata] = useState(
    onlineData?.thankyou_info || thankyouData
  );
  const [introductiondata, setIntroductiondata] = useState(
    onlineData?.introduction_info || overviewData
  );
  // const [questions, setQuestionsdata] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const NewJobSchema = Yup.object().shape({
    introduction_info: Yup.string().required('Content is required'),
    thankyou_info: Yup.string().required('Thank you ')
  });

  //   const defaultValues = useMemo(
  //     () => ({
  //         introduction_info: onlineData?.introduction_info || overviewData,
  //       thankyou_info: onlineData?.thankyou_info || thankyouData
  //     }),
  //     []
  //   );
  React.useEffect(() => {
    const initialFetching = async () => {
      if (uiFields) {
        setScreenLoader(true);
        const {sql_data} = uiFields['create_sql'];
        try {
          const data: any = {
            sql_data: sql_data,
            data: {
              module_id: onlineData.inserted_id,
              course_overview_id: onlineData?.course_overview_id || uniqueId
            },
            operation: 'QUESTIONSEARCH'
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const result = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          // setDropDownData((prevData: any[]) => {
          //   console.log('Previous Data:', prevData);
          //   const resultData = result.data; // Assuming `result.data` contains the JSON object

          //   const transformedData = Object.keys(resultData).map(key => ({
          //     Name: key,
          //     Values: resultData[key].map((item: any) => ({
          //       label: item.label,
          //       value: item.value
          //     }))
          //   }));

          //   console.log('Transformed Data:', transformedData);

          //   return [...(prevData || []), ...transformedData];
          // });
          // setOptionsRendered(true);
          const transformedResult = result.data.map((item: any) => {
            return {
              ...item,
              // Parse JSON fields or set them to empty arrays if they are null
              choices: item.choices ? JSON.parse(item.choices) : null,
              correctMatches: item.correctMatches
                ? JSON.parse(item.correctMatches)
                : null,
              additionalChoices: item.additionalChoices
                ? JSON.parse(item.additionalChoices)
                : null,
              descriptive_enforce_word_limit:
                item.descriptive_enforce_word_limit
                  ? JSON.parse(item.descriptive_enforce_word_limit)
                      .descriptive_enforce_word_limit
                  : null,
              // Parse the descriptive_enforce_word_limit_length JSON or set it to null
              descriptive_enforce_word_limit_length:
                item.descriptive_enforce_word_limit_length
                  ? JSON.parse(item.descriptive_enforce_word_limit_length)
                      .descriptive_enforce_word_limit_length
                  : null,
              TrueFalse: item.TrueFalse
                ? JSON.parse(item.TrueFalse).TrueFalse
                : null
              // Add any additional transformations here if needed
            };
          });

          setQuestionData(transformedResult);
          setScreenLoader(false);
        } catch (e) {
          setScreenLoader(false);
          const errMessage = getErrorMessage(e);
          enqueueSnackbar(errMessage, SnackBarConfig.getError());
        }
      }
    };
    initialFetching();
  }, []);
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    formState: {errors, isDirty}
  } = useForm({
    resolver: yupResolver(NewJobSchema),
    defaultValues: {
      introduction_info: onlineData?.introduction_info || overviewData,
      thankyou_info: onlineData?.thankyou_info || thankyouData
    }
  });
  const values = watch();
  const onSubmit = async (datavalue: any) => {
    try {
      const operations = 'UPDATE';
      datavalue.id = onlineData.inserted_id;
      datavalue.Page = 2;
      datavalue.course_overview_id = uniqueId;
      const {sql_data} = uiFields['create_sql'];
      // datavalue.bloburls = datavalue.bloBurls[0].blobUrl;
      setScreenSave(true);
      const data: any = {
        sql_data: sql_data,
        data: datavalue,
        operation: operations
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      const transformedResult = result.data.map((item: any) => {
        return {
          ...item,
          // Parse JSON fields or set them to empty arrays if they are null
          ipRestrictions: item.ipRestrictions
            ? JSON.parse(item.ipRestrictions)
            : null
          // Add any additional transformations here if needed
        };
      });
      setOnlineData(transformedResult[0]);
      setScreenSave(false);
      // Send data to the server
    } catch (e) {
      console.log('ee', e);
      setScreenSave(false);
    }
  };

  const handleQuestionUpload = async (datavalue: any, operation: string) => {
    try {
      const operations = operation;
      // if (operation === 'UPDATE') {
      //   datavalue.id = onlineData.inserted_id;
      // }
      datavalue.ModuleOnlineTestList_id = onlineData.inserted_id;
      const {sql_data} = uiFields['add_question_crud'];
      // datavalue.bloburls = datavalue.bloBurls[0].blobUrl;
      setQuestionLoader(true);
      const valueStored = {
        ...datavalue,
        choices: datavalue?.choices ? JSON.stringify(datavalue.choices) : null,
        correctMatches: datavalue?.correctMatches
          ? JSON.stringify(datavalue.correctMatches)
          : null,
        additionalChoices: datavalue?.additionalChoices
          ? JSON.stringify(datavalue.additionalChoices)
          : null,
        course_overview_id: uniqueId
      };
      const data: any = {
        sql_data: sql_data,
        data: valueStored,
        operation: operations
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      // setQuestionData(result.data[0]);
      setQuestionLoader(false);
      if (operation === 'INSERT') {
        datavalue.id = result.data[0].id; // Assign the inserted ID from the result
        if (result.data[0].correctMatches) {
          datavalue.correctMatches = JSON.parse(
            result.data[0].correctMatches
          ).map(
            (item: {
              id: any;
              match_the_following_left_value: any;
              match_the_following_right_value: any;
              sequence: any;
            }) => ({
              id: item.id,
              match_the_following_left_value:
                item.match_the_following_left_value,
              match_the_following_right_value:
                item.match_the_following_right_value
            })
          );
        }

        // Parse and replace values for choices
        if (result.data[0].choices) {
          datavalue.choices = JSON.parse(result.data[0].choices).map(
            (item: {
              id: any;
              OptionText: any;
              OptionDescription: any;
              is_single_multiple_trueOrFalse_correct_option: any;
            }) => ({
              id: item.id,
              OptionText: item.OptionText,
              OptionDescription: item.OptionDescription,
              is_single_multiple_trueOrFalse_correct_option:
                item.is_single_multiple_trueOrFalse_correct_option
            })
          );
        }

        // Parse and replace values for additionalChoices
        if (result.data[0].additionalChoices) {
          datavalue.additionalChoices = JSON.parse(
            result.data[0].additionalChoices
          ).map(
            (item: {
              id: any;
              match_the_following_additional_right_value: any;
            }) => ({
              id: item.id,
              match_the_following_additional_right_value:
                item.match_the_following_additional_right_value
            })
          );
        }
        datavalue.descriptive_enforce_word_limit = result.data[0]
          .descriptive_enforce_word_limit
          ? JSON.parse(result.data[0].descriptive_enforce_word_limit)
              .descriptive_enforce_word_limit
          : null;
        // Parse the descriptive_enforce_word_limit_length JSON or set it to null
        datavalue.descriptive_enforce_word_limit_length = result.data[0]
          .descriptive_enforce_word_limit_length
          ? JSON.parse(result.data[0].descriptive_enforce_word_limit_length)
              .descriptive_enforce_word_limit_length
          : null;
        datavalue.TrueFalse = result.data[0].TrueFalse
          ? JSON.parse(result.data[0].TrueFalse).TrueFalse
          : null;

        datavalue.sequence = result.data[0].sequence; // Assign the inserted sequence from the result
        return datavalue;
      } else {
        if (result.data[0].correctMatches) {
          datavalue.correctMatches = JSON.parse(
            result.data[0].correctMatches
          ).map(
            (item: {
              id: any;
              match_the_following_left_value: any;
              match_the_following_right_value: any;
              sequence: any;
            }) => ({
              id: item.id,
              match_the_following_left_value:
                item.match_the_following_left_value,
              match_the_following_right_value:
                item.match_the_following_right_value
            })
          );
        }

        // Parse and replace values for choices
        if (result.data[0].choices) {
          datavalue.choices = JSON.parse(result.data[0].choices).map(
            (item: {
              id: any;
              OptionText: any;
              OptionDescription: any;
              is_single_multiple_trueOrFalse_correct_option: any;
            }) => ({
              id: item.id,
              OptionText: item.OptionText,
              OptionDescription: item.OptionDescription,
              is_single_multiple_trueOrFalse_correct_option:
                item.is_single_multiple_trueOrFalse_correct_option
            })
          );
        }

        // Parse and replace values for additionalChoices
        if (result.data[0].additionalChoices) {
          datavalue.additionalChoices = JSON.parse(
            result.data[0].additionalChoices
          ).map(
            (item: {
              id: any;
              match_the_following_additional_right_value: any;
            }) => ({
              id: item.id,
              match_the_following_additional_right_value:
                item.match_the_following_additional_right_value
            })
          );
        }
        datavalue.descriptive_enforce_word_limit = result.data[0]
          .descriptive_enforce_word_limit
          ? JSON.parse(result.data[0].descriptive_enforce_word_limit)
              .descriptive_enforce_word_limit
          : null;
        // Parse the descriptive_enforce_word_limit_length JSON or set it to null
        datavalue.descriptive_enforce_word_limit_length = result.data[0]
          .descriptive_enforce_word_limit_length
          ? JSON.parse(result.data[0].descriptive_enforce_word_limit_length)
              .descriptive_enforce_word_limit_length
          : null;
        datavalue.TrueFalse = result.data[0].TrueFalse
          ? JSON.parse(result.data[0].TrueFalse).TrueFalse
          : null;
        datavalue.sequence = result.data[0].sequence;
        return datavalue;
      }
      // Send data to the server
    } catch (e) {
      console.log('ee', e);
      setQuestionLoader(false);
    }
  };
  const saveChanges = useCallback(async () => {
    if (Object.keys(errors).length > 0) {
      return false;
    }

    if (
      isDirty ||
      onlineData?.thankyou_info === undefined ||
      onlineData?.thankyou_info == null
    ) {
      try {
        await handleSubmit(onSubmit)();
        return true;
      } catch (e) {
        console.error('Save failed:', e);
        return false;
      }
    }
    return true; // No changes to save
  }, [errors, isDirty, onlineData, handleSubmit, onSubmit]);
  useEffect(() => {
    setSaveRef.current = saveChanges;
    return () => {
      setSaveRef.current = null; // Clean up on unmount
    };
  }, [setSaveRef, saveChanges]);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClicks = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpening(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDivClick = () => setEditMode(true);
  const handleCancel = () => {
    setValue('thankyou_info', thanksdata);
    setEditMode(false);
  };
  const handleDivClicks = () => setIntromode(true);
  const handleCancels = () => {
    setValue('introduction_info', introductiondata);
    setIntromode(false);
  };
  const handleSave = () => {
    const thanksdatas = watch('thankyou_info');
    setThanksdata(thanksdatas);
    setEditMode(false);
    const introData = watch('introduction_info');
    setIntroductiondata(introData);
    setIntromode(false);
  };
  const handleCloseAddquestion = () => {
    setEditQuestions(null);
    setOpening(false);
  };

  const handleEditQuestion = (id: any) => {
    setEditQuestions(id);
    setOpening(true);
  };
  // Function to handle data received from the QuestionForm
  const handleSaveData = async (formData: any) => {
    if (editQuestions) {
      await handleQuestionUpload(formData, 'UPDATE');
      const updatedQuestions = questionsData.map((question: {id: any}) =>
        question.id === editQuestions.id ? formData : question
      );
      // setQuestionsdata(updatedQuestions);
      setQuestionData(updatedQuestions);
      setEditQuestions(null);
      handleCloseAddquestion();
    } else {
      const data = await handleQuestionUpload(formData, 'INSERT');
      // setQuestionsdata([...questions, data]);
      setQuestionData([...questionsData, data]);
      setEditQuestions(null);
      handleCloseAddquestion();
    }
    handleClose();
  };

  return (
    <Box sx={{width: '100%', p: 3}}>
      <Card variant="outlined" sx={{padding: '1vh 1.5vh', marginBottom: '2vh'}}>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="h1" sx={{mt: 2, mb: 1}}>
            Introduction
          </Typography>
          {intromode && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}>
              <Button
                type="reset"
                variant="outlined"
                sx={{mb: '3px', mr: 2}}
                onClick={handleCancels}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{mb: '3px'}}
                onClick={handleSave}>
                Save
              </Button>
            </div>
          )}
        </Box>
        {intromode ? (
          <div>
            <Controller
              name="introduction_info"
              control={control}
              render={({field, fieldState: {error}}) => (
                <Editor
                  simple
                  id="introduction_info"
                  toolbarpresent={true}
                  value={field.value}
                  onChange={field.onChange}
                  error={!!error}
                  helperText={
                    !!error && (
                      <FormHelperText error={!!error} sx={{px: 2}}>
                        {error && error?.message}
                      </FormHelperText>
                    )
                  }
                  sx={{
                    '.ql-editor': {
                      maxHeight: '25vh',
                      overflowY: 'auto'
                    }
                  }}
                />
              )}
            />
          </div>
        ) : (
          <div style={{border: 'groove', borderRadius: '8px'}}>
            <div style={{margin: '1vh 3vh'}} onClick={handleDivClicks}>
              {parse(introductiondata)}
            </div>
          </div>
        )}
      </Card>
      <Card variant="outlined" sx={{padding: '1vh 1.5vh', marginBottom: '2vh'}}>
        <Typography variant="h1" sx={{mt: 2, mb: 1}}>
          Questions
        </Typography>
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between'
          }}>
          <Typography variant="body1" sx={{mb: 1}}>
            Total questions: {questionsData.length} | Total Marks:{' '}
            {questionsData.reduce(
              (acc: any, q: {QuestionMarks_id: any}) =>
                acc + q.QuestionMarks_id,
              0
            )}{' '}
            | Duration: 10 mins
          </Typography>
          <div
            style={{
              backgroundColor: '#212B36',
              borderRadius: '0px',
              marginBottom: '8px'
            }}>
            <Button
              id="add-question-button"
              variant="contained"
              onClick={handleClicks}
              sx={{p: '4px', borderRadius: '0px'}}>
              Add Question
            </Button>
            {/* <Button
              variant="contained"
              onClick={handleClick}
              endIcon={
                <Iconify
                  sx={{display: 'block', m: 0}}
                  icon={
                    open
                      ? 'eva:arrow-ios-upward-fill'
                      : 'eva:arrow-ios-downward-fill'
                  }
                />
              }
              sx={{p: '4px 8px', borderRadius: '0px', minWidth: '40px'}}
            /> */}
          </div>
          <Menu
            id="add-question-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}>
            <MenuItem onClick={handleClose}>Add from Question Bank</MenuItem>
            <MenuItem onClick={handleClose}>Add Random Question</MenuItem>
          </Menu>
        </div>
        {questionsData.length <= 0 && (
          <Box
            sx={{
              my: 2,
              border: 'groove',
              display: 'flex',
              alignItems: 'center',
              borderRadius: '8px',
              minHeight: '47vh',
              maxHeight: '47vh',
              overflowY: 'auto',
              justifyContent: 'center'
            }}>
            <div>
              {/* <img
                src="path_to_your_image/robot_empty_state.png"
                alt="No questions"
                style={{
                  width: 200,
                  height: 'auto',
                  margin: 'auto',
                  display: 'flex',
                  alignItems: 'center'
                }}
              /> */}
              <Typography
                variant="h6"
                sx={{my: 2, display: 'flex', justifyContent: 'center'}}>
                No questions added
              </Typography>
              <Typography variant="body1">
                Start adding questions to your assessment. Click on Add Question
                to begin.
              </Typography>
            </div>
          </Box>
        )}
        {questionsData.length > 0 && (
          <Box
            sx={{
              my: 2,
              border: 'groove',
              borderRadius: '8px',
              p: '0.8vh'
            }}>
            <DragDropQuestion handleEditQuestion={handleEditQuestion} />
          </Box>
        )}
      </Card>

      <Card variant="outlined" sx={{padding: '1vh 1.5vh'}}>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography variant="h1" sx={{mt: 2, mb: 1}}>
            Thanking You
          </Typography>
          {editMode && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}>
              <Button
                type="reset"
                variant="outlined"
                sx={{mb: '3px', mr: 2}}
                onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{mb: '3px'}}
                onClick={handleSave}>
                Save
              </Button>
            </div>
          )}
        </Box>
        {editMode ? (
          <div>
            <Controller
              name="thankyou_info"
              control={control}
              render={({field, fieldState: {error}}) => (
                <Editor
                  simple
                  id="thankyou_info"
                  toolbarpresent={true}
                  value={field.value}
                  onChange={field.onChange}
                  error={!!error}
                  helperText={
                    !!error && (
                      <FormHelperText error={!!error} sx={{px: 2}}>
                        {error && error?.message}
                      </FormHelperText>
                    )
                  }
                  sx={{
                    '.ql-editor': {
                      maxHeight: '25vh',
                      overflowY: 'auto'
                    }
                  }}
                />
              )}
            />
          </div>
        ) : (
          <div style={{border: 'groove', borderRadius: '8px'}}>
            <div
              style={{margin: '1vh 3vh', minHeight: '14vh', maxHeight: '14vh'}}
              onClick={handleDivClick}>
              {parse(thanksdata)}
            </div>
          </div>
        )}
      </Card>
      <QuestionFormOnlineTest
        open={opening}
        handleEditQuestion={editQuestions}
        onClose={handleCloseAddquestion}
        onSave={handleSaveData}
      />
    </Box>
  );
};

export default QuestionSetupOnlineTest;
